import { useEffect, useState } from 'react';
import { useGoodsBasic } from '../../../queries/useGoodsBasic';
import { bridge, isNil } from 'shared/src/utils';

export const useLogViewRecommendedModal = (mode: 'like' | 'cart') => {
  const [isLogged, setIsLogged] = useState(false);
  const { data: goodsBasic } = useGoodsBasic();
  useEffect(() => {
    if (isNil(goodsBasic)) return;

    if (isLogged) return;
    const categories = goodsBasic.display_categories?.[0] ?? null;

    if (mode === 'cart') {
      bridge.logAnalyticsEvent({
        name: 'VIEW_CART_RECOMMENDED_GOODS_MODAL',
        analytics: {
          EVENT_TYPE: 'VIEW_CART_RECOMMENDED_GOODS_MODAL',
          CATEGORY_NAME: categories?.name,
          CATEGORY_SNO: categories?.sno.toString(),
          GOODS_NAME: goodsBasic?.name,
          GOODS_SNO: goodsBasic?.sno.toString(),
          SCREEN: 'GOODS_DETAIL',
        },
      });
      setIsLogged(true);
    }

    if (mode === 'like') {
      bridge.logAnalyticsEvent({
        name: 'VIEW_LIKE_RECOMMENDED_GOODS_MODAL',
        analytics: {
          EVENT_TYPE: 'VIEW_LIKE_RECOMMENDED_GOODS_MODAL',
          CATEGORY_NAME: categories?.name,
          CATEGORY_SNO: categories?.sno.toString(),
          GOODS_NAME: goodsBasic?.name,
          GOODS_SNO: goodsBasic?.sno.toString(),
          SCREEN: 'GOODS_DETAIL',
        },
      });
      setIsLogged(true);
    }
  }, [goodsBasic, isLogged, mode]);
};
